export const assertEnvVar = (
  envVar: string | undefined,
  envVarName: string
) => {
  if (envVar === undefined) {
    throw new Error(`Expected env var "${envVarName}" is missing`);
  }

  return envVar;
};
